
import React from 'react';
import Layout from '../../components/Layout';
import Contact from './Contact';

const title = 'Contact Us';

function action({ store }) {
  const siteSettings = store.getState().siteSettings?.data || {};
  return {
    title,
    description: siteSettings?.metaDescription,
    component: (
      <Layout>
        <div className="withoutPageMainContainer">
          <Contact
            title={title}
            contactEmail={siteSettings?.contactEmail}
            contactPhoneNumber={siteSettings?.contactPhoneNumber}
            whatsApp={siteSettings?.whatsApp}
          />
        </div>
      </Layout>
    ),
  };
}

export default action;
